import { BodyTextMedium, Button, HeadingText50 } from '@modernhealth/vital-components';
import styled from '@emotion/styled';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { layout } from '@modernhealth/vital-foundation';
import { useHistory } from 'react-router-dom';

import { ReactComponent as Illustration } from 'src/public/ds/illustrations/fish.svg';
import { analyticsClient } from 'src/shared/services/analytics';

const Wrapper = styled.div({
    paddingTop: '3.25rem',
    paddingLeft: layout.containerPaddingX,
    paddingRight: layout.containerPaddingX,
    paddingBottom: layout.footerHeight,
});

const ContentWrapper = styled.div({
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: '29rem',
    margin: '0 auto',
});

export const CirclesErrorComponent: React.FC = () => {
    const { t } = useTranslation();
    const history = useHistory();

    return (
        <Wrapper>
            <ContentWrapper>
                <Illustration width={200} />
                <HeadingText50 centered marginTop={25}>
                    {t('error_page_title')}
                </HeadingText50>
                <BodyTextMedium centered marginTop={16} marginBottom={25}>
                    {t('error_page_description')}
                </BodyTextMedium>
                <Button
                    onClick={() => {
                        analyticsClient.trackClick('Circles Error Page: Go to explore page', {
                            page_name: 'Circles Error Page',
                            button_copy: 'Go to explore page',
                        });
                        history.replace('/dashboard');
                    }}
                    variant="secondary"
                    size="large"
                >
                    {t('go_to_explore_page')}
                </Button>
            </ContentWrapper>
        </Wrapper>
    );
};
